import { Component, OnInit, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';

import { ExamEvaluationConfigurationDTO, ExamEvaluation, ExamItemEvaluation } from '../../model/exam-evaluation-configuration';
import { ExamEvaluationConfService } from '../../services/examEvaluationConf/examEvaluationConf.service';
import { ConfigurationControlService } from '../../services/configuration/configurationControl.service';
import { TokenControlService } from '../../services/state/tokenControl.service';
import { Item } from '../../model/item';
import { NgxSpinnerService } from '../../../../node_modules/ngx-spinner';
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { ClipboardService } from './clipboard.service';

@Component({
  selector: 'app-exam-evaluation-conf',
  templateUrl: './exam-evaluation-conf.component.html',
  styleUrls: ['./exam-evaluation-conf.component.css']
})
export class ExamEvaluationConfComponent implements OnInit, OnChanges {

  @Input() itemActual: Item;
  @Input() examEvaluation: string;
  @Input() respuesta: string;


  start = false;

  //variable para obtener la respuesta del servicio de consulta de configuración
  examEvaluationConf: ExamEvaluationConfigurationDTO[];

  //variable para controlar en el formulario las respuestas de la evaluación
  arrayObject: ExamEvaluation;
  oriArrayObject: ExamEvaluation;

  correctAnswerElement: any;

  constructor(private examEvaluationConfService: ExamEvaluationConfService,
    private _tokenController: TokenControlService,
    public _configurationControlService: ConfigurationControlService,
    private _spinner: NgxSpinnerService,
    public _answerController: AnswerControlService,
    private clipboardService: ClipboardService) { }

  ngOnDestroy(): void {
    this.clipboardService.unblockCopyPasteEvents();
  }

  ngOnInit() {

    this.clipboardService.blockCopyPasteEvents();
    const token = this._tokenController.token;
    const apliId = this._configurationControlService.examConfiguration.apliId;

    //Consulta configuracion con los datos para la evaluacion del examen
    this.examEvaluationConfService.getExamEvaluationConf(token.tokenId, token.token, apliId)
      .then((response: ExamEvaluationConfigurationDTO[]) => {

        this.examEvaluationConf = response;

        //valida si el tipo está presente en la lista de configuración       
        for (let element of this.examEvaluationConf) {
          for (let exam of this.examEvaluationConf) {
            if (exam.tipo == element.longitud) {
              element.isSelected = true;
              element.listToSelect = this.examEvaluationConf.filter((conf) => { return conf.tipo == element.longitud });
              break;
            }
          }
        }

        this.examEvaluationConfService.examEvaluationConf = this.examEvaluationConf;
        this.examEvaluationConfService.listaRespuestasExtendias = this.examEvaluationConf.filter((conf) => { return conf.tipo == 'RETEX' });
        this.examEvaluationConfService.listaElementosEvaluar = this.examEvaluationConf.filter((conf) => { return conf.tipo == 'EVAL' });
        this.examEvaluationConfService.listaElementosValoracion = this.examEvaluationConf.filter((conf) => { return conf.tipo == 'ELEM' });
        this.examEvaluationConfService.listaValorReferencia = this.examEvaluationConf.filter((conf) => { return conf.tipo == 'VALRE' });
        this.examEvaluationConfService.listaEnunciados = this.examEvaluationConf.filter((conf) => { return conf.tipo == 'ENCAB' });
        this.examEvaluationConfService.listaRespuestaMaterial = this.examEvaluationConf.filter((conf) => { return conf.tipo == 'REMAT' });

        //reconstruye el panel a partir de la informacion del item
        this._spinner.show();
        setTimeout(() => {
          this.showPanelEvaluation();
          this._spinner.hide();
        }, 200);

      });
  }

  //Método que escucha el evento cuando cambia un item
  ngOnChanges(changes: SimpleChanges) {
    if (changes == null || (changes && changes.itemActual)) {
      this._spinner.show();
      //reconstruye el panel a partir de la informacion del nuevo item      
      setTimeout(() => {
        this.showPanelEvaluation();
        this._spinner.hide();
      }, 1000);
    }
    if (changes && changes.respuesta && this.arrayObject) {
      let correctAnswer = !changes.respuesta.currentValue || changes.respuesta.currentValue == 'O' ? '' : changes.respuesta.currentValue;
      let respuestaExt: ExamEvaluationConfigurationDTO;
      //Valida el elemento del formulario que debe tener la respuesta correcta
      for (let i = 0; i < this.examEvaluationConfService.listaRespuestasExtendias.length; i++) {
        respuestaExt = this.examEvaluationConfService.listaRespuestasExtendias[i];
        if (respuestaExt.longitud == 'OBLIGA') {
          this.arrayObject.respuestasExtendias[i].value = correctAnswer;
          this.arrayObject.respuestasExtendias[i].readOnly = true;
        }
      }
    }
  }

  /** Modifica la apariencia del panel para ajustarse al contenido */
  showPanelEvaluation() {

    //Variable para controlar la apertura del panel de evaluación de la prueba    
    const elem = document.querySelector('.navMenu') as HTMLElement;
    const topNav = document.querySelector('.barra-botones-navegacion-top') as HTMLElement;


    const clientWidth = topNav.clientWidth;

    const editorContainer = document.querySelector('#divScroll') as HTMLElement;
    const panelEvaluation = document.querySelector('app-exam-evaluation-conf') as HTMLElement;
    const footer = document.querySelector('footer-visualizer footer') as HTMLElement;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    if (panelEvaluation) {
      panelEvaluation.style.height = Number(screenHeight - footer.clientHeight - elem.offsetHeight - topNav.offsetHeight) + 'px';
      const offsetTop = elem.offsetHeight + topNav.offsetHeight - 2;
      panelEvaluation.style.marginTop = offsetTop + 'px';
    }

    this.examEvaluationConfService.answersForEvaluation = 0;

    //Actualiza los valores de las opciones de respuesta      
    if (document.querySelectorAll("ck-editor").length / 2 >= 1) {
      this.examEvaluationConfService.answersForEvaluation = document.querySelectorAll("ck-editor").length / 2;
    }

    if (document.querySelectorAll("#divAnswer .radio input").length > 0) {
      this.examEvaluationConfService.answersForEvaluation = document.querySelectorAll("#divAnswer .radio input").length;
    }

    if (document.querySelectorAll(".respuestas-insor .radio input").length > 0) {
      this.examEvaluationConfService.answersForEvaluation = document.querySelectorAll(".respuestas-insor .radio input").length;
    }

    let elemValoracion: ExamEvaluationConfigurationDTO = null;
    let controlOpc = 0;
    for (let i = 0; i < this.examEvaluationConfService.listaElementosValoracion.length; i++) {

      elemValoracion = this.examEvaluationConfService.listaElementosValoracion[i];
      if (elemValoracion.etiqueta.toUpperCase().indexOf('OPCION') >= 0 || elemValoracion.etiqueta.toUpperCase().indexOf('OPCIÓN') >= 0) {
        controlOpc++;
        if (controlOpc > this.examEvaluationConfService.answersForEvaluation) {
          elemValoracion.isVisible = false;
        }
        else {
          elemValoracion.isVisible = true;
        }
      }
      else {
        elemValoracion.isVisible = true;
      }

    }

    //Reconstruye el objeto a partir de la cantidad de respuestas del item
    this.arrayObject = this.initializeArrayObject(this.itemActual.itemId, this.examEvaluation);
    this.examEvaluationConfService.oriArrayObject = JSON.parse(JSON.stringify(this.arrayObject));
    this.examEvaluationConfService.arrayObject = this.arrayObject;

  }

  //inicializa el objeto arrayObject
  public initializeArrayObject(itemIdActual, examEvaluation, ): ExamEvaluation {

    let etiquetaValoracion = '';
    let etiquetaEvaluar = '';
    let elemValoracion = null;
    let elemEvaluar = null;
    let respuestaE = null;
    let controlOpc = 0;
    let mbControlOpc = false;
    this.arrayObject = new ExamEvaluation();

    let jsonObject = {};
    try {
      if (!examEvaluation || examEvaluation == '') {
        jsonObject = this.examEvaluationConfService.getLocalStorage(itemIdActual);
      }
      else {
        jsonObject = JSON.parse(examEvaluation);
      }
    } catch (e) { }


    if (jsonObject == null || jsonObject == '') {
      jsonObject = {};
    }

    for (let i = 0; i < this.examEvaluationConfService.listaElementosValoracion.length; i++) {
      elemValoracion = this.examEvaluationConfService.listaElementosValoracion[i];
      etiquetaValoracion = elemValoracion.comentario ? elemValoracion.comentario : elemValoracion.etiqueta.substr(0, 4);
      mbControlOpc = false;
      if (elemValoracion.etiqueta.toUpperCase().indexOf('OPCION') >= 0 || elemValoracion.etiqueta.toUpperCase().indexOf('OPCIÓN') >= 0) {
        controlOpc++;
        mbControlOpc = true;
      }

      this.arrayObject.elementosValoracion[i] = [];

      //Recorre los criterios de evaluación tipo EVAL: Pertinencia,Coherencia,Relevancia,Justificacion
      for (let j = 0; j < this.examEvaluationConfService.listaElementosEvaluar.length; j++) {

        this.arrayObject.elementosValoracion[i][j] = new ExamItemEvaluation('');

        elemEvaluar = this.examEvaluationConfService.listaElementosEvaluar[j];
        etiquetaEvaluar = elemEvaluar.comentario ? elemEvaluar.comentario : elemEvaluar.etiqueta.substr(0, 4);

        //Si el elemento de valoración es de una opción de respuesta del Item
        if (!mbControlOpc || (mbControlOpc && controlOpc <= this.examEvaluationConfService.answersForEvaluation)) {
          if (jsonObject[etiquetaValoracion + etiquetaEvaluar]) {
            this.arrayObject.elementosValoracion[i][j].value = jsonObject[etiquetaValoracion + etiquetaEvaluar];
          }
          else if (this.examEvaluationConfService.isPartOfList(elemEvaluar.longitud)) {
            this.arrayObject.elementosValoracion[i][j].value = this.examEvaluationConfService.EXAM_EVAL_DEFAULT_SELECT;
          }
          else {
            this.arrayObject.elementosValoracion[i][j].value = '';
          }
        }
      }
    }

    //Prepara la estructura para la segunda parte de la evaluación    
    for (let i = 0; i < this.examEvaluationConfService.listaRespuestasExtendias.length; i++) {

      this.arrayObject.respuestasExtendias[i] = new ExamItemEvaluation('');

      respuestaE = this.examEvaluationConfService.listaRespuestasExtendias[i];

      if (respuestaE.longitud && respuestaE.longitud === 'OBLIGA' && this.itemActual.type !== 'open' && this.itemActual.type !== 'open_insor') {
        this.arrayObject.respuestasExtendias[i].value = '';
        this.arrayObject.respuestasExtendias[i].readOnly = true;
      }
      if (jsonObject[respuestaE.comentario]) {
        this.arrayObject.respuestasExtendias[i].value = jsonObject[respuestaE.comentario];
      }
      else { this.arrayObject.respuestasExtendias[i].value = ''; }
    }

    //Inicializa los inputs de cada elemnto dee evaluacion con la funcion onChangeSelectedElement
    for (let i = 0; i < this.examEvaluationConfService.listaElementosValoracion.length; i++) {
      for (let j = 0; j < this.examEvaluationConfService.listaElementosEvaluar.length; j++) {
        this.onChangeSelectedElement(i, j);
      }
    }

    return this.arrayObject;
  }

  onChangeSelectElementExtValue(indexChild) {
    this.examEvaluationConfService.validationFormReset(indexChild);
  }

  onChangeElementExtValue(indexChild, longitud) {

    this.examEvaluationConfService.validationFormReset(indexChild);

    let list = this.arrayObject ? this.arrayObject.respuestasExtendias : [];

    if (list && list[indexChild] && list[indexChild].value.length + 1 > Number(longitud)) {

      //Recorta el valor del string del Input, segun la longitud permitida
      setTimeout(() => {
        list[indexChild].value = list[indexChild].value.substr(0, longitud);
      }, 5);
    }
  }

  onChangeInputElementValue(indVal, indElenVal, longitud) {

    this.examEvaluationConfService.validationFormReset(indVal, indElenVal);

    let list = this.arrayObject ? this.arrayObject.elementosValoracion : [];

    if (list && list[indVal][indElenVal] && list[indVal][indElenVal].value.length + 1 > Number(longitud)) {

      //Recorta el valor del string del Input, segun la longitud permitida
      setTimeout(() => {
        this.arrayObject.elementosValoracion[indVal][indElenVal].value =
          this.arrayObject.elementosValoracion[indVal][indElenVal].value.substr(0, longitud);
      }, 5);

    }
  }

  onChangeSelectedElement(indVal, indElenVal) {

    this.examEvaluationConfService.validationFormReset(indVal, indElenVal);

    setTimeout(() => {

      let evalElement: ExamEvaluationConfigurationDTO;
      let validElement: ExamEvaluationConfigurationDTO;
      let value = null;
      let lastIndx = null;
      let mbControlJusti = false;

      for (let i = 0; i < this.arrayObject.elementosValoracion[indVal].length; i++) {

        value = this.arrayObject.elementosValoracion[indVal][i].value;
        evalElement = this.examEvaluationConfService.listaElementosEvaluar[i];

        //si es un tipo lista
        if (evalElement.listToSelect) {
          lastIndx = evalElement.listToSelect.length - 1;
          validElement = evalElement.listToSelect[lastIndx];
          //si la respuesta no es la última en la selección
          if (value !== validElement.longitud && value !== validElement.etiqueta) {
            mbControlJusti = true;
            break;
          }
        }
      }

      for (let i = 0; i < this.arrayObject.elementosValoracion[indVal].length; i++) {

        evalElement = this.examEvaluationConfService.listaElementosEvaluar[i];
        //si no es un tipo lista 
        if (!evalElement.listToSelect) {
          if (!mbControlJusti) {
            this.arrayObject.elementosValoracion[indVal][i].readOnly = true;
            this.arrayObject.elementosValoracion[indVal][i].value = '';
          }
          else {
            this.arrayObject.elementosValoracion[indVal][i].readOnly = false;
          }
        }
      }

    }, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.showPanelEvaluation();
  }

}

